import CheckIcon from '@mui/icons-material/Check';

function CustomCheckedIcon() {
  return (
    <span style={{ display: 'inline-block' }}>
      <div
        style={{
          width: '24px',
          height: '24px',
          backgroundColor: '#5256A6',
          borderRadius: '8px',
          border: 'none',
          position: 'relative',
        }}
      >
        <CheckIcon
          style={{
            color: 'white',
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            fontSize: '18px',
          }}
          sx={{
            p: '0px !important',
          }}
        />
      </div>
    </span>
  );
}

export default CustomCheckedIcon;
